module.exports = __webpack_public_path__ + "mein_konto_icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mein_konto_icon.png
// module id = 65
// module chunks = 0